var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutputZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4134,
    cy: 7.58621,
    r: 6.83621,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.2069,
    cy: 13.7933,
    r: 5.4569,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82759 5.97434C4.82759 7.30744 3.74689 8.38813 2.41379 8.38813C1.08069 8.38813 0 7.30744 0 5.97434C0 4.64124 1.08069 3.56055 2.41379 3.56055C3.74689 3.56055 4.82759 4.64124 4.82759 5.97434Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputZones);
export default __webpack_public_path__ + "static/media/OutputZones.4038ebe9224b8ffc39b335d439536daf.svg";
export { ForwardRef as ReactComponent };